
import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, EffectCoverflow, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '../Assets/WebsiteCss/homepage.css';
import { Container, Row, Col, Button, Card, Carousel } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { FaTools, FaIndustry, FaCogs, FaBoxOpen } from "react-icons/fa";
import { FaUserTie, FaHardHat } from 'react-icons/fa';
import { GiCookingPot, GiPopcorn } from 'react-icons/gi';
import { MdPrecisionManufacturing } from 'react-icons/md';
import { BiGroup } from 'react-icons/bi';
import { MdFastfood, } from "react-icons/md";
import { IoIosCheckmark } from "react-icons/io";
import logo from '../Assets/food/namkeen_logo_main.png'
import banner1 from '../Assets/food/HomeBack1.jpeg'
import banner2 from '../Assets/food/Home2.jpg'
import banner3 from '../Assets/food/Home3.jpg'
import banner4 from '../Assets/Image/10.jpg'
import banner5 from '../Assets/food/factory.jpg'
import banner6 from '../Assets/food/42.jpeg'
import banner7 from '../Assets/food/Home4.jpg'
import banner8 from '../Assets/food/owner.jpg'
import aboutimg from '../Assets/food/aboutHome.jpg'
import sohanpapadi from '../Assets/food/sonpapdi.jpg'
import alubhujiya from '../Assets/food/aloo_bhujia.jpg'
import dryfruitmix from '../Assets/food/dryfruits.webp'
import chanamasala from '../Assets/food/chaana.webp'
import indori from '../Assets/food/indori.webp'
import fariyalisabudana from '../Assets/food/shabudanna.webp'
import gujaratimix from '../Assets/food/papdi.webp'
import moongdal from '../Assets/food/moong_dal.webp'
import leftImg from '../Assets/food/namkeen.png'
import rightImg from '../Assets/food/namkeen2.png'
import { useNavigate } from 'react-router-dom';
import { GoDotFill } from "react-icons/go";
import contactlabour from '../Assets/Image/ContactLabour.png'

import { Helmet } from "react-helmet";
import { text } from 'framer-motion/client';
import { FaUserCog, FaStore } from "react-icons/fa";
import { GiChefToque } from 'react-icons/gi';
import { GiSlicedBread, GiCook } from "react-icons/gi";
import { LuChefHat } from "react-icons/lu";
import { FaBowlFood } from "react-icons/fa6";
import { GiCheckMark } from "react-icons/gi";

const HeroBannerText = ({ heading, heading2, img2 }) => {
  const navigate = useNavigate();


  return (

    <div className="hero-text-overlay">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            {img2 && <img src={img2} alt="Logo" style={{ width: '200px', marginBottom: '20px' }} />}
            <h1 className="hero-heading">
              {heading}
            </h1>
            {heading2 && <h2 style={{ fontSize: 35 }} className='Sliderh2'>{heading2}</h2>}

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default function HomePage() {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);


  const slideContent = [
    {
      img: banner1,
      img2: logo,
      heading: null,
      heading2: null,

    },
    {
      img: banner2,

      heading2: null,
      heading: null,
    },
    {
      img: banner7,

      heading2: null,
      heading: null,
    },

    {
      img: banner3,

      heading2: null,
      heading: null,
    },
    {
      img: banner5,

      heading2: null,
      heading: null,
    },

  ];

  const products = [

    { name: "Indori Khatta Mitha", image: indori },
    { name: "Alu Bhujiya", image: alubhujiya },
    { name: "Fariyali Sabudana", image: fariyalisabudana },
    { name: "Gujarati Papdi", image: gujaratimix },
    { name: "Moong Daal (Masala)", image: moongdal },
    { name: "Sohan Papdi", image: sohanpapadi },

    { name: "Dry Fruit Mix", image: dryfruitmix },
    { name: "Chana Jor Masala", image: chanamasala },
  ];

  const quotes = [
    "It tastes just like the traditional namkeen we grew up eating.  ",
    "Once we started buying this, we stopped looking for other brands.",
    "Every packet feels freshly made.",
    "My family loves the taste, especially with evening tea.",
    "The variety is amazing, and every product tastes unique."
  ];

  const serviceFeatures = [
    {
      title: "Manpower Expertise",
      icon: <FaUserTie size={35} color="rgb(231 184 2)" />,
      description:
        "Skilled professionals with experience in managing namkeen production units, ensuring smooth operations, labor management, and production timelines.",
    },
    {
      title: "Snacks Expertise",
      icon: <MdFastfood size={35} color="rgb(231 184 2)" />,
      description:
        "Expert Karigars trained in preparing authentic Rajasthani namkeen with precise techniques to maintain taste, texture, and tradition.",
    },
    {
      title: "Packing Excellence",
      icon: <FaBoxOpen size={35} color="rgb(231 184 2)" />,
      description:
        "Trained workers who operate, monitor, and maintain automatic/semi-automatic namkeen packaging machines efficiently.",
    },
    {
      title: "Labor Contractor Service",
      icon: <FaHardHat size={35} color="rgb(234 184 2)" />,
      description:
        "Support staff who assist in frying, seasoning, mixing, and moving products as per supervisor's instructions.",
    },
  ];

  const serviceFeatures2 = [
    {
      title: "Supervisor/Quality control Staff",
      icon: <FaUserTie size={40} color="#23326a" />,
      description:
        "Experienced professionals specializing in namkeen production management, delivering seamless operations, disciplined workforce handling, and on-time production execution.",
    },
    {
      title: "Namkeen snacks Karigar",
      icon: <MdFastfood size={40} color="#23326a" />,
      description:
        "Our skilled Namkeen and snacks professionals bring expertise, precision, and creativity to every batch, ensuring high-quality, delicious treats for your business.",
    },
    {
      title: "Machine Operators ",
      icon: <MdPrecisionManufacturing size={40} color="#23326a" />,
      description:
        "Trained workers who operate, monitor, and maintain automatic/semi-automatic namkeen packaging machines efficiently. Skilled machine operators ensuring safe, precise, and efficient production.",
    },
    {
      title: "Semi-Skilled Karigars",
      icon: <FaHardHat size={40} color="#23326a" />,
      description:
        "Support staff who assist in frying, seasoning, mixing, and moving products as per supervisor's instructions. Reliable semi-skilled karigars delivering efficient support and quality workmanship.",
    },
    {
      title: "Packing department staff",
      icon: <FaBoxOpen size={40} color="#23326a" />,
      description:
        "Our efficient packing department staff ensures every product is carefully handled, securely packed, and delivered on time, maintaining the highest standards of quality . ",
    },
    {
      title: "Bakery Karigar",
      icon: <GiSlicedBread size={40} color="#23326a" />,
      description:
        "Our experienced bakery workers craft delicious baked goods with precision, creativity, and consistency, ensuring every product delights your customers. Skilled bakery workers crafting fresh and high-quality baked products.",
    },
    {
      title: "Full factory labor supply",
      icon: <FaUserCog size={40} color="#23326a" />,
      description:
        "We provide a reliable and skilled full factory labor force, equipped to handle production, assembly, and operational tasks efficientl, ensuring smooth and uninterrupted factory operations.",
    },
    {
      title: "Sweets (Mithai) Karigar",
      icon: <FaStore size={40} color="#23326a" />,
      description:
        "Our experienced mithai workers craft traditional and modern sweets with skill and care, ensuring every treat is delicious and perfectly made.",
    },
    {
      title: "Bhujia Karigar",
      icon: <LuChefHat size={40} color="#23326a" />,
      description:
        "We provide trained Bhujia Karigars who expertly handle preparation, frying, and seasoning to deliver authentic taste, consistency, and high-quality output.",
    },
    {
      title: "Sev Karigar",
      icon: <GiCook size={40} color="#23326a" />,
      description:
        "We provide trained Sev Karigars who specialize in sev preparation, frying, and seasoning, ensuring uniform texture, authentic taste, and high production efficiency.",
    },
    {
      title: "Chivda Karigar",
      icon: <FaBowlFood size={40} color="#23326a" />,
      description:
        "We provide trained Chivda Karigars who handle roasting, mixing, seasoning, and quality control to deliver delicious, consistent, and high-quality chivda.",
    },
    {
      title: "Popcorn Karigar",
      icon: <GiPopcorn size={40} color="#23326a" />,
      description:
        "We provide trained Popcorn Karigars who specialize in popcorn preparation, seasoning, and quality control, delivering crisp texture, great taste, and high production efficiency.",
    }

  ];

  const items = [
    "Salted snacks Karigar ",
    "Sweets Karigar",
    "Snacks Karigar",
    "Bakery Karigar",
    "Packing department staff ",
    "Machine Operators",
    "Full Factory Labor Supply",
    "Supervisor Control Staff",
    "Quality Control Staff"
  ];
  return (


    <>
      <div className="mainnav min-vh-100 ">

        <Helmet>
        {/* Basic Meta */}
        <title>Karigar India Namkeen Labour Contractor</title>
        <meta name="description" content="Trusted and well-established Skilled Manpower & Labour Contractor for Namkeen, Sweets, Snacks, and Bakery units in India. Hire experienced Karigars for Bhujia, Sev, Chivda, Mithai, Snacks, Bakery, and Packing staff." />
        <meta name="keywords" content="Karigar India, Namkeen Karigar, Sweets Karigar, Snacks Karigar, Bakery Karigar, Labour Contractor, Skilled Manpower, Bhujia, Sev, Chivda, Mithai, Packing Staff" />
        <meta name="author" content="Karigar India" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Karigar India Namkeen Labour Contractor" />
        <meta property="og:description" content="Providing skilled manpower solutions for Namkeen, Sweets, Snacks, and Bakery manufacturing units across India." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.karigarindia.in" />
        <meta property="og:image" content="https://www.karigarindia.in/logo.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Karigar India Namkeen Labour Contractor" />
        <meta name="twitter:description" content="Hire skilled Karigars for Namkeen, Sweets, Snacks, and Bakery production. Full factory labor supply and packing staff available." />
        <meta name="twitter:image" content="https://www.karigarindia.in/logo.png" />

        {/* Favicon */}
        <link rel="icon" href="/logo.png" />
      </Helmet>

        <div className="slider-wrapper mb-4">
          <Carousel controls={false} indicators={true} interval={2000} fade pause={false} touch={false}>

            {slideContent.map((slide, i) => (
              <Carousel.Item key={i}>
                <div className="slider-item">
                  <img src={slide.img} alt={`Slide-${i}`} className="slider-img" />

                  {/* Dark Overlay */}
                  <div className="slider-overlay"></div>

                  {/* Text content over the image */}
                  <HeroBannerText

                    heading={slide.heading}
                    heading2={slide.heading2}

                  />

                  {/* Right Gradient (if needed) */}
                  {/* <div className="right-gradient"></div> */}
                </div>
              </Carousel.Item>
            ))}

          </Carousel>
        </div>


        <Container className='mt-3'>
          <div className="mb-2 mt-5" >
            <h2 className=" middletext mb-3" data-aos="zoom-in">About Karigar India</h2>

            <Row>
              <Col lg={5} className="d-flex justify-content-center" >
                <img
                  src={aboutimg}
                  alt=""
                  style={{ height: "300px", width: '90%', objectFit: 'fill', borderRadius: "8px" }}
                />
              </Col>
              <Col lg={7}>
                <p className='homePara' style={{ textAlign: "justify", fontSize: 15 }}>
                  <b> Karigar India Namkeen Labour Contractor</b> is a trusted and well-established Skilled Manpower & Labour Contractor service in India, offering complete workforce solutions for namkeen, sweets, snacks, and bakery manufacturing units. We specialize in providing highly experienced namkeen karigars skilled in bhujia, sev, chivda, dal, and mixed namkeen production. Along with namkeen experts, we also supply mithai karigars, snacks karigars, bakery karigars, and trained packing department staff to handle hygienic and efficient packaging operations.

                </p>
                <h5>Services We Have</h5>
                <div className="grid-container">

                  {items.map((item, index) => (
                    <div key={index} className="grid-item">
                      <GiCheckMark style={{ fontSize: 12, color: "rgb(167, 0, 0)" }} /> {item}
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>

          <section className=" pb-5" style={{ backgroundColor: "#f8f9fa" }}>
            <Container>
              <Row className="text-center mb-4">
                <Col>
                  <h2
                    className="middletext fw-bold text-uppercase mt-2"
                    style={{ color: "rgb(167 0 0)" }}
                    data-aos="zoom-in"
                  >
                   Meet Mr. Bhojmal Salvi

                  </h2>
                  {/* <p className="lead text-muted">
                    From <b>production to packaging</b> we deliver
                    <b> comprehensive labour contracting solutions</b> powered by a
                    <b> perfect balance of automated systems and skilled hands.</b>
                    <br />

                  </p> */}

                </Col>
              </Row>

              <Row className="g-4 ">

                <Col md={6} className="services-text">

                  <h2 className="fw-bold mb-3">

                  </h2>

                  {/* <p className="text-muted mb-3" style={{ textAlign: 'justify' }}>
                    We handle the complete labour contracting process, from manufacturing through final packing, combining modern machines and skilled manpower for superior efficiency.
                  </p> */}

                  {/* Feature List */}
                  {/* <ul className="list-unstyled mb-1">
                    {serviceFeatures.map((service, idx) => (
                      <li key={idx} className="d-flex align-items-center mb-3">
                        <span className="me-3 text-success fs-5">
                          {service.icon}
                        </span>
                        <span className="fw-medium">{service.title}</span>
                      </li>
                    ))}
                  </ul> */}
                  <p style={{textAlign:'justify', fontSize:16}}>Mr. Bhojmal Salvi is the owner and driving force behind Namkeen Manpower Expertise. With a strong passion for the savory snack industry, he is committed to delivering specialized manpower solutions tailored to the specific needs of namkeen snack manufacturers. </p>

                   <p style={{textAlign:'justify', fontSize:16}}> His journey began with a clear understanding of how essential a skilled and dependable workforce is to the namkeen production process. Identifying a gap in areas such as labor contracting, quality control, and production supervision, Mr. Salvi founded Namkeen Manpower Expertise to support manufacturers in maintaining efficiency, consistency, and high-quality standards.</p>

                  {/* Button */}
                  {/* <Button
                    className="custom-btn px-4 py-2"
                    onClick={() => navigate("/services")}
                  >
                    More <FaArrowRight className="ms-2" />
                  </Button> */}

                </Col>

                {/* LEFT SIDE – IMAGE COLLAGE */}
                <Col md={6}>
                  <Card className="border-0 shadow-lg">
                    <Card.Img
                      src={banner8}   // your single image
                      className="rounded"
                      style={{ height: "300px", objectFit: "fill" }}
                    />
                  </Card>
                </Col>

                {/* RIGHT SIDE – FEATURES (UNCHANGED) */}



              </Row>

            </Container>
          </section>

          <section className="" style={{ backgroundColor: "#f8f9fa" }}>
            <Container>
              <Row className="text-center" style={{ marginBottom: '5rem' }}>
                <Col>
                  <h2
                    className="middletext mb-3" data-aos="zoom-in"
                  >
                    Our Services
                  </h2>
                  <p className="lead text-muted">
                    End-to-end <b>labour contracting from manufacturing</b>  to final packing, powered by <b>automation and skilled hands</b>  for optimal efficiency.

                  </p>
                  <b>We Provide Services : </b>
                </Col>
              </Row>


              <Row className="justify-content-center mt-5  ">
                {serviceFeatures2.map((service, idx) => (
                  <Col md={3} xs={12} key={idx} style={{ marginBottom: "5rem" }}>
                    <div className="choose-card">

                      {/* ICON CIRCLE */}
                      <div className="icon-circle">
                        {service.icon}
                      </div>

                      {/* CARD CONTENT */}
                      <div className="card-content">
                        <h4>{service.title}</h4>
                        <p style={{ textAlign: 'center' }}>{service.description}</p>
                      </div>

                    </div>
                    {/* <Card className="provideservice   h-100">
                                   <Card.Body className="text-center">
                                     {service.icon}
                                     <h5 className="mt-3">{service.title}</h5>
                                     <p className="text-muted">{service.description}</p>
                                   </Card.Body>
                                 </Card> */}
                  </Col>
                ))}
              </Row>

            </Container>
          </section>

          <div className="mb-2 mt-1">
            <h2 className="section-heading middletext mb-4" data-aos="zoom-in"> Explore Our Tasty Namkeen Collection </h2>
            <span class="heading-divider"></span>
            <Row>
              {products.map((product, index) => (
                <Col md={3} sm={6} xs={6} key={index} className="mb-4">
                  <div className="product-box">
                    <img src={product.image} alt={product.name}
                      className="product-img" style={{ height: '200px' }} />
                    <div className="overlay">
                      <h5>{product.name}</h5>
                    </div>
                  </div>
                </Col>
              ))}

            </Row>
            <div className="d-flex justify-content-center mt-2">
              <Button className="custom-btn" onClick={() => navigate('/ourproducts')}>
                View More <FaArrowRight className="ml-2" />
              </Button>
            </div>
          </div>



          <Row className="testimonial-wrapper position-relative">

            <h2 className=" middletext mb-5" data-aos="zoom-in">
              Feedback from Our Customer
            </h2>


            {/* Left Image (Bottom Left) */}
            <Col md={3} sm={12} xs={12}>
              <img src={leftImg} alt="Left" className="side-img left-img" />
            </Col>

            {/* Center Text Slider */}
            <Col md={7} sm={12} xs={12} className="text-slider">
              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 4000 }}
                loop
              >
                {quotes.map((text, index) => (
                  <SwiperSlide key={index}>
                    <p className="quote">“ {text} ”</p>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>

            {/* Right Image (Top Right) */}
            <Col md={2} sm={12} xs={12}>
              <img src={rightImg} alt="Right" className="side-img right-img" />
            </Col>

          </Row>


        </Container>

      </div>

    </>
  );
}
